import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course04 from "../../../course/course-04/course";
import lesson0427 from "../lesson-27/lesson";
import lesson0428 from "../lesson-28/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "8b730110-a38a-430e-bb45-e0b781a4d2ea",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0427),
    lesson: lesson0427,
  },
  {
    id: "5e7b85de-ada9-4c3f-900d-7d9db347e569",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0428),
    lesson: lesson0428,
  },
];

export default lessonLinks;
